import { membersNumber } from 'config/constants/constants';

export const digitaleTransformation = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Digitale Transformation',
  url: 'https://www.boldare.com/digitale-transformation/',
  description: `Boldare unterstützt Unternehmen wie sonnen bei der digitalen Transformation durch ganzheitliche Produktentwicklung, agile Scrum-Prozesse und hochqualifizierte, selbstorganisierte Projektteams. Mit über ${membersNumber} Mitarbeitenden europaweit garantiert Boldare höchste Qualität in Softwareentwicklung und Design.`,
  publisher: {
    '@type': 'Organization',
    name: 'Boldare',
    url: 'https://www.boldare.com',
    employee: {
      '@type': 'Person',
      name: 'Malte Kalkoffen',
      jobTitle: 'CEO Endios',
    },
    numberOfEmployees: membersNumber,
    foundingDate: '2013',
  },
  mainEntity: {
    '@type': 'CreativeWork',
    name: 'Digitale Transformation bei sonnen',
    description:
      'sonnen, ein führendes Unternehmen im Bereich erneuerbarer Energien, hat seine Nutzergemeinschaft stark vergrößert und benötigte eine effiziente Integration und Straffung seiner digitalen Geschäftsprozesse. Boldare unterstützte durch Aufstockung der Softwareentwicklung und agile Methoden.',
  },
};
